module.exports = __webpack_public_path__ + "img/avatar.357cdcd8.png";